export default "__VITE_ASSET__CJ4h237s__"